import { render, staticRenderFns } from "./BookingInfo.vue?vue&type=template&id=cf0461a0"
import script from "./BookingInfo.vue?vue&type=script&lang=js"
export * from "./BookingInfo.vue?vue&type=script&lang=js"
import style0 from "./BookingInfo.vue?vue&type=style&index=0&id=cf0461a0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports